import { render, staticRenderFns } from "./BiddingClassificationGrid.vue?vue&type=template&id=9a56b234&"
import script from "./BiddingClassificationGrid.vue?vue&type=script&lang=js&"
export * from "./BiddingClassificationGrid.vue?vue&type=script&lang=js&"
import style0 from "./BiddingClassificationGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports